/* jshint esversion: 6 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import Slider from "react-slick";
import { FaChevronRight } from "react-icons/fa6";
import { IoCartOutline } from "react-icons/io5";
import { LuPlus } from "react-icons/lu";
import { HiMiniMinusSmall } from "react-icons/hi2";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d9488] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[30px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronLeft color="#fff" size={22} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d9488] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[30px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronRight color="#fff" size={22} />
    </div>
);

export const DetailsSheet = ({ item, index, ImgBaseUrl, LoadingRef, ApiBaseUrl, currency, isShow, setisShow, setIsLoginShow, Docid, productId, details, productList, setDetails, setproductList, setTotalCart, totalCart }) => {

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const handleAddToCart = (item) => {

        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (!Userid) {
            setisShow("");
            setIsLoginShow(true);
            return;
        }

        setLoading(true);
        LoadingRef.current = true;

        const payload = {
            uid: Userid,
            doctor_id: Docid,
            prod_id: productId,
            pro_price: item.price,
            pro_ptype: item.title,
            pro_qty: item.cart_qty,
            pro_qty_type: 1,
            mode: 1,
        };

        const updatedDetails = details.map(detail =>
            detail.title === item.title
                ? { ...detail, cart_qty: detail.cart_qty + 1 }
                : detail
        );

        const updatedProductList = productList.map(product =>
            product.id === productId
                ? { ...product, price_detail: updatedDetails }
                : product
        );

        axios.post(`${ApiBaseUrl}/customer/cart_detail`, payload)
            .then((response) => {
                // console.log(response);
                setLoading(false);
                LoadingRef.current = false;
                setDetails(updatedDetails);
                setproductList(updatedProductList);
                setTotalCart(prevCount => prevCount + 1);
            })
            .catch((error) => {
                console.error('Failed to add item to cart:', error);
            });
    };


    const handleRemoveToCart = (item) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (LoadingRef.current) {
            return;
        }

        if (Userid) {

            setLoading(true);
            LoadingRef.current = true;

            const Data = {
                uid: Userid,
                doctor_id: Docid,
                prod_id: productId,
                pro_price: item.price,
                pro_ptype: item.title,
                pro_qty: item.cart_qty,
                pro_qty_type: 2,
                mode: 1
            };

            const updatedDetails = details.map(detail =>
                detail.title === item.title
                    ? { ...detail, cart_qty: detail.cart_qty - 1 }
                    : detail
            );

            const updatedProductList = productList.map(product =>
                product.id === productId
                    ? { ...product, price_detail: updatedDetails }
                    : product
            );

            axios.post(`${ApiBaseUrl}/customer/cart_detail`, Data)
                .then((res) => {
                    // console.log(res);
                    setLoading(false);
                    LoadingRef.current = false;
                    setDetails(updatedDetails);
                    setproductList(updatedProductList);
                    setTotalCart(totalCart - 1);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    return (<div key={index} className="border-t-[1px] border-[#8080803b] py-[8px]">
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-[10px]">
                <img src={ImgBaseUrl + isShow.img} className='border-[1px] border-[#8080803b] rounded-[10px] w-[80px] h-[80px] object-cover' alt="" />
                <div className="leading-[22px]">
                    <h1 className='font-[500] text-[17px]'>{isShow.name}</h1>
                    <span className='text-gray-500'>{item.title}</span>
                    <div className="flex items-center gap-[10px]">
                        <h1 className='font-[500] text-[18px]'>{currency}{item.price}</h1>
                        <span className='line-through text-gray-500'>{currency}{item.base_price}</span>
                        <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500]'>{item.discount}% OFF</h1>
                    </div>
                </div>
            </div>
            <div className='border-[1px] border-[#0d9488] text-[#0d9488] font-[500] text-[18px] rounded-[10px] py-[2px]'>
                {loading
                    ? <div className="px-[25px] py-[2px]">
                        <div className="loader2"></div>
                    </div>
                    : item.cart_qty
                        ? <div className="flex items-center px-[5px] gap-[10px]">
                            <button onClick={() => handleRemoveToCart(item)}><HiMiniMinusSmall /></button>
                            <h1>{item.cart_qty}</h1>
                            <button onClick={() => handleAddToCart(item)}><LuPlus /></button>
                        </div>
                        : <button onClick={() => handleAddToCart(item)} className='px-[20px]' >{t("Add")}</button>}
            </div>
        </div>
    </div>)
}

export const ImgLoad = ({ url, customestyle }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    return (
        <img
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    )
}

const StoreHomePage = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow, selectproduct, setSelectProduct } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [bannerList, setbannerList] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectId, setSelectId] = useState();
    const [productList, setproductList] = useState([]);
    const [detailsShow, setDetailsShow] = useState(false);
    const [detailsData, setDetailsData] = useState([]);
    const [isShow, setisShow] = useState("");
    const [details, setDetails] = useState([]);
    const [productId, setProductId] = useState();
    const [totalCart, setTotalCart] = useState(0);
    const [cartData, setCartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiloading, setApiLoading] = useState(false);
    const [detailslod, setDetailsLod] = useState(false);

    const LoadingRef = useRef(false);
    const LocalData = sessionStorage.getItem("Docdetails");

    if (LocalData) {
        var { Categoreyid, Docid } = JSON.parse(LocalData);
    }

    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        centerMode: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, centerMode: true } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true, centerMode: true } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: false } },
        ],
    };

    const Categories = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 10,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1710, settings: { slidesToShow: 9, slidesToScroll: 1 } },
            { breakpoint: 1510, settings: { slidesToShow: 8, slidesToScroll: 1 } },
            { breakpoint: 1310, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1145, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 995, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const settings2 = {
        arrows: false,
        dots: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        const Userid = secureLocalStorage.getItem("Userid") || "0";

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/sub_category_list`, { uid: Userid, doctor_id: Docid, category_id: Categoreyid })
                .then((res) => {
                    // console.log("sub_category_list", res);
                    if (res.data.ResponseCode === 200) {
                        setLoading(false);
                        setbannerList(res.data.banner_list);
                        setCategory(res.data.sub_category);
                        HandleProductListGet(res.data.sub_category[0].id);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [LocalData]);

    useEffect(() => {
        if (!selectproduct) return;
        HandleDetailsGet(selectproduct);
    }, [selectproduct]);

    const HandleProductListGet = (category_id) => {
        setSelectId(category_id);
        
        const Userid = secureLocalStorage.getItem("Userid") || "0";

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/sub_product_list`, { uid: Userid, doctor_id: Docid, category_id })
                .then((res) => {
                    // console.log("sub_product_list", res);
                    const { tot_cart_qty, product_list } = res.data;
                    setApiLoading(false);
                    setTotalCart(tot_cart_qty);
                    setproductList(product_list);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleDetailsGet = (id) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setDetailsLod(true);
        setDetailsShow(true);

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/product_detail`, { uid: Userid, doctor_id: Docid, prod_id: id })
                .then((res) => {
                    // console.log("product_detail", res);
                    setDetailsData([res.data.product]);
                    setDetailsLod(false);
                    setSelectProduct("");
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleShowPriceDetails = (e, items, index) => {
        e.stopPropagation();
        setDetailsShow(false);
        setProductId(items.id);
        setisShow({ name: items.product_name, img: index === 1 ? items.product_image[0] : items.product_image });
        setDetails(items.price_detail);
        const Data = { id: items.id, price_detail: items.price_detail };
        setCartData([...cartData, Data]);
    };

    useEffect(() => {
        document.body.style.overflow = "auto";
    }, [loading]);

    const HandleSelectCategoris = (id) => {
        setApiLoading(true);
        HandleProductListGet(id);
    }

    return (
        <div className='pb-[50px] content-wrapper store-page'>
            {false ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="slider-container mt-[20px]">
                        <Slider {...settings}>
                            {
                                bannerList.map((item, index) => {
                                    return <div key={index}>
                                        <img src={ImgBaseUrl + item} className='h-[300px] max-_430_:h-[200px] object-cover w-[100%] px-1 rounded-[20px]' alt="Slider Img" />
                                    </div>
                                })
                            }
                        </Slider>
                    </div>

                    <div className="width-container">
                        <div className="mt-[20px]">
                            <h1 className='d-title'>{t("Categories")}</h1>
                            <div className="mt-[15px]">
                                <Slider {...Categories}>
                                    {
                                        category.map((item, index) => {
                                            const [firstWord, ...restWords] = item.name.split(" ");
                                            const secondLine = restWords.join(" ");
                                            return (
                                                <div
                                                    onClick={() => HandleSelectCategoris(item.id)}
                                                    key={index}
                                                    className={`h-[180px] w-[120px] flex flex-col items-center justify-between cursor-pointer rounded-[10px] p-[8px] border-[2px] ${selectId === item.id && "border-[#0d9488]"}`}
                                                >
                                                    <div className="flex items-center justify-center">
                                                        <ImgLoad
                                                            url={ImgBaseUrl + item.image}
                                                            customestyle="h-[100px] object-contain"
                                                        />
                                                    </div>
                                                    <div className="text-center mt-[10px]">
                                                        <h1 className={`text-[15px] max-_770_:text-[14px] leading-4 font-[500] ${selectId === item.id && "text-[#0d9488]"}`}>{firstWord}</h1>
                                                        <h1 className={`text-[15px] max-_770_:text-[14px] leading-4 font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis ${selectId === item.id && "text-[#0d9488]"}`}>{secondLine}</h1>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </Slider>

                            </div>
                        </div>
                        <div className="mt-5 lab-details">
                            <h1 className="d-title">{t("Bestseller Products")}</h1>

                            <div className="mt-4 flex flex-wrap items-center gap-5">
                                {false ? (
                                    <Loading CustomeStyle="w-full h-[300px] flex items-center justify-center" />
                                ) : productList?.length >= 1 ? (
                                    productList.map((item, index) => {
                                        const totalCartQty = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                                        const priceInfo = item.price_detail[0];

                                        return (
                                            <div
                                                key={index}
                                                onClick={() => HandleDetailsGet(item.id)}
                                                className="card-box cursor-pointer"
                                            >
                                                <div className="relative">
                                                    <ImgLoad
                                                        url={ImgBaseUrl + item.product_image}
                                                        customestyle="photo object-cover"
                                                    />

                                                    {priceInfo.discount !== 0 && (
                                                        <div className="absolute top-2 left-0 bg-orange-400 py-0.5 px-2.5 rounded-r-md">
                                                            <div className="flex items-center gap-1.5">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 24 24"
                                                                    fill="#ffffff"
                                                                    stroke="none"
                                                                >
                                                                    <path d="M12.01 2.011c..."></path>
                                                                </svg>
                                                                <h1 className="text-white font-medium">{priceInfo.discount}% OFF</h1>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="p-2.5 mt-1">
                                                    <h1 className="font-medium text-lg">{item.product_name}</h1>

                                                    <div className="flex items-center justify-between gap-5 mt-2">
                                                        <div>
                                                            <h1 className="font-medium text-base">
                                                                {currency}
                                                                {priceInfo.price}
                                                            </h1>
                                                            <span className="line-through text-gray-500 text-sm">
                                                                {currency}
                                                                {priceInfo.base_price}
                                                            </span>
                                                        </div>

                                                        <div className="text-center">
                                                            <button
                                                                onClick={(e) => HandleShowPriceDetails(e, item)}
                                                                className="border border-[#0d9488] text-[#0d9488] font-medium text-base rounded-lg py-0.5"
                                                            >
                                                                {totalCartQty ? (
                                                                    <div className="flex items-center px-1.5 gap-2">
                                                                        <HiMiniMinusSmall />
                                                                        <h1>{totalCartQty}</h1>
                                                                        <LuPlus />
                                                                    </div>
                                                                ) : (
                                                                    <h1 className="px-5">{t("Add")}</h1>
                                                                )}
                                                            </button>
                                                            <h1 className="text-[#0d9488] text-xs mt-1">
                                                                {item.price_detail.length} {t("Option")}
                                                            </h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="mx-auto py-12">
                                        <h1 className="font-medium text-lg text-center">
                                            {t("No Store available")} <br />
                                            {t("in your area.")}
                                        </h1>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </div>}

            {detailsShow && <div onClick={() => setDetailsShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[700px] scroll-container">
                    {false
                        ? null
                        : <div className="">
                            {detailsData.map((item, index) => {
                                const singleLineText = item?.description.replace(/\r\n|\r|\n/g, '<br />');
                                const TotalCart = item.price_detail.reduce((acc, curr) => acc + curr.cart_qty, 0);
                                return <div key={index} className="">
                                    <div key={index} className="slider-container mb-[20px]">
                                        <Slider {...settings2}>
                                            {
                                                item.product_image.map((item, index) => {
                                                    return <div key={index} className='outline-none'>
                                                        <img src={ImgBaseUrl + item} className='h-[300px] object-contain w-[100%] px-1 rounded-[20px]' alt="Slider Img" />
                                                    </div>
                                                })
                                            }
                                        </Slider>
                                    </div>
                                    <div className="mt-[10px]">
                                        {item.prescription_require === "Required" && <h1 className='font-[500] text-red-700'>{t("Prescription Required")}</h1>}
                                        <h1 className='font-[500] text-[18px]'>{item.product_name}</h1>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center gap-[10px]">
                                                <h1 className='font-[500] text-[18px]'>{currency}{item.price_detail[0].price}</h1>
                                                <span className='line-through text-gray-500'>{currency}{item.price_detail[0].base_price}</span>
                                                {item.price_detail[0].discount !== 0 && <h1 className='bg-orange-400 text-white px-[10px] rounded-[50px] text-[14px] font-[500]'>{item.price_detail[0].discount}% OFF</h1>}
                                            </div>
                                            <div className="text-center">
                                                <button onClick={(e) => HandleShowPriceDetails(e, item, 1)} className='border-[1px] border-[#0d9488] text-[#0d9488] font-[500] text-[18px] rounded-[10px] py-[2px]'>
                                                    {TotalCart
                                                        ? <div className="flex items-center px-[5px] gap-[10px]">
                                                            <HiMiniMinusSmall />
                                                            <h1>{TotalCart}</h1>
                                                            <LuPlus />
                                                        </div>
                                                        : <h1 className='px-[20px]'>{t("Add")}</h1>}
                                                </button>
                                                <h1 className='text-[#0d9488]'>{item.price_detail.length} {t("Option")}</h1>
                                            </div>
                                        </div>
                                        <span className='text-[18px]'>Unit</span>
                                        <p className='text-gray-500' dangerouslySetInnerHTML={{ __html: singleLineText }} />
                                    </div>
                                </div>
                            })}
                        </div>}
                </div>
            </div>}

            {isShow && <div onClick={() => setisShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[650px] scroll-container">
                    <h1 className='font-[500] text-[20px] mb-[5px]'>{isShow.name}</h1>

                    {details.map((item, index) => {
                        return <DetailsSheet item={item} LoadingRef={LoadingRef} index={index} ImgBaseUrl={ImgBaseUrl} ApiBaseUrl={ApiBaseUrl} currency={currency} isShow={isShow} setisShow={setisShow} setIsLoginShow={setIsLoginShow} Docid={Docid} productId={productId} details={details} productList={productList} setDetails={setDetails} setproductList={setproductList} setTotalCart={setTotalCart} totalCart={totalCart} />
                    })}
                    <button onClick={() => setisShow("")} className='payment-btn mt-[10px]'>{t("Done")}</button>
                </div>
            </div>}

            {(productList?.length >= 1 && totalCart !== 0) && <Link to="/checkout" className="w-[100%] flex justify-center fixed items-end left-0 right-0 bottom-[10px] z-[888]">
                <div className="bg-[#0d9488] p-[5px] rounded-[50px] flex items-center gap-[10px]">
                    <div className="bg-[#1a1694] rounded-[50px] p-[8px]">
                        <IoCartOutline className='text-white text-[25px]' />
                    </div>
                    <div className="leading-[18px] text-white text-start">
                        <h1 className='font-[500] text-[17px]'>{t("View Cart")}</h1>
                        <span className='text-[16px] '>{totalCart} {t("Items")}</span>
                    </div>
                    <FaChevronRight className='text-white text-[20px]' />
                </div>
            </Link>}
        </div>
    )
}

export default StoreHomePage;
/* jshint ignore:end */